export default [
    {
      path: "/profile",
      component: () => import("../views/profile/profile"),
      // meta: { title: global.productName }
    }
  ];
  